
/*get timestamps*/
var unix = Math.round((new Date()).getTime() / 1000);
var expire = 1*31*24*60*60;

/*if cookie consent and not set or expired*/
$('html').mouseleave(function() {
    if(
        localStorage['policy'] != null &&
        ((localStorage['exitintent'] == null) || (localStorage['exitintent'] < unix-expire))
    ){
        $('.exit').css('display','block');
        localStorage['exitintent'] = unix;
    }
});

/*dismiss*/
$( document ).ready(function() {
    $('.exit .dismiss').bind("click",function() {
        $('.exit').css('display','none');
    });
});



